import React from 'react';

const NotFound = () => (
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    textAlign: 'center',
    padding: '20px',
    backgroundColor: '#000',
    color: '#fff'
  }}>
    <h1 style={{ fontSize: '4rem', marginBottom: '1rem' }}>404</h1>
    <h2 style={{ fontSize: '2rem', marginBottom: '1rem' }}>Page Not Found</h2>
    <p style={{ marginBottom: '2rem' }}>
      The page you're looking for doesn't exist.
    </p>
    <a 
      href="/" 
      style={{
        color: '#fff',
        textDecoration: 'underline',
        fontSize: '1.2rem'
      }}
    >
      Return Home
    </a>
  </div>
);

export default NotFound;
